import { type MCPServerInfo } from '../../types';

const ToriiServer: MCPServerInfo = {
  serverId: 'TORII',
  name: 'Torii',
  slug: 'torii',
  description: 'Torii MCP Server',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://api.toriihq.com/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default ToriiServer;
